<template>
  <div :class="['min-bag-container',showLoveList?'show-cart':'']">
    <template v-if="wishtList.length<=0&&loaded ||hasLogin">
      <div class="no-data">
        <div class="title">暂无心愿单</div>
        <div class="btn go-cart" @click="goMyWishList()">
          <div>查看我的心愿清单</div>
          <img class="icon" src="../../assets/image/icon/shop-cart-left.svg" />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="cart-list">
        <div class="cart-item" v-for="(item,index) in wishtList" :key="index">
          <div class="cart-img" @click.stop="goPage(item.baseDTO.friendlyUrl,item.baseDTO,index)">
            <img :src="item.baseDTO.imageList[0].originalUrl" />
          </div>

          <div class="cart-info">
            <div class="cart-info-detail">
              <div class="good-name">
                <span>{{item.baseDTO.name}}</span>
                <!-- <span class="last-pro">最后一件</span> -->
                <span
                  class="last-pro"
                  v-if="(item.status==0||item.status==3)&&item.skuStock==1"
                >最后一件</span>
                <span class="last-pro" v-if="item.status==1">已下架</span>
                <span class="last-pro" v-if="item.status==2">售罄</span>
              </div>
              <!-- 选择了sku的去item的discountPrice-->
              <template v-if="item.skuId">
                <template v-if="item.discountPrice!='0'&&item.discountPrice!=undefined">
                  <div class="originprice">¥{{$utils.toThousands(item.price) }}</div>
                  <div class="currprice">¥{{$utils.toThousands(item.discountPrice)}}</div>
                </template>
                <template v-else>
                  <div class="currprice">¥{{$utils.toThousands(item.price)}}</div>
                </template>
              </template>
              <!-- 没有选择sku取item.baseDTO的discountPrice-->
              <template v-else>
                <template
                  v-if="item.baseDTO.discountPrice!='0'&&item.baseDTO.discountPrice!=undefined"
                >
                  <div class="originprice">¥{{$utils.toThousands(item.baseDTO.price) }}</div>
                  <div class="currprice">¥{{$utils.toThousands(item.baseDTO.discountPrice)}}</div>
                </template>
                <template v-else>
                  <div class="currprice">¥{{$utils.toThousands(item.baseDTO.price)}}</div>
                </template>
              </template>
              <!-- 没有选择sku取item.baseDTO的discountPrice-->

              <div class="good-size hint" v-if="ishasskuid &&chooseIndex==index">请选择规格</div>
              <div class="good-size" v-if="item.skuValue&&item.skuId">
                尺码.
                <span
                  class="value"
                  v-if="item.skuValue&&item.skuValue2&&item.skuValue3"
                >{{item.skuValue}}；{{item.skuValue2}};{{item.skuValue3}}</span>
                <span
                  class="value"
                  v-else-if="item.skuValue&&item.skuValue2"
                >{{item.skuValue}}；{{item.skuValue2}}</span>
                <span class="value" v-else-if="item.skuValue">{{item.skuValue}}</span>
              </div>
              <div
                :class="['good-size',item.guigeList.length>1 ?'more':'']"
                v-else
                v-for="(gitem,gindex) in item.guigeList"
                :key="gindex"
              >
                {{gitem.name}}.
                <span
                  class="value"
                  v-if="gindex == 0"
                >{{ item.skuValue ? item.skuValue:'选择'+gitem.name}}</span>

                <span
                  class="value"
                  v-if="gindex == 1"
                >{{ item.skuValue2 ? item.skuValue2:'选择'+gitem.name}}</span>
                <span
                  class="value"
                  v-if="gindex == 2"
                >{{ item.skuValue3 ? item.skuValue3:'选择'+gitem.name}}</span>

                <Select
                  style="width:3rem"
                  :label-in-value="true"
                  @on-change="change_status(index,gindex)"
                  v-model="item.skuValue"
                  v-if="gindex == 0"
                >
                  <Option
                    v-for="(item,indexskuValue) in gitem.childs"
                    :key="indexskuValue"
                    :label="index"
                    :value="item.value"
                    :disabled="item.isgray"
                  >{{ item.value }}</Option>
                </Select>
                <Select
                  style="width:3rem"
                  :label-in-value="true"
                  @on-change="change_status(index,gindex)"
                  v-model="item.skuValue2"
                  v-if="gindex == 1"
                >
                  <Option
                    v-for="(item,indexskuValue2) in gitem.childs"
                    :key="indexskuValue2"
                    :label="index"
                    :value="item.value"
                    :disabled="item.isgray"
                  >{{ item.value }}</Option>
                </Select>
                <Select
                  style="width:3rem"
                  :label-in-value="true"
                  @on-change="change_status(index,gindex)"
                  v-model="item.skuValue3"
                  v-if="gindex == 2"
                >
                  <Option
                    v-for="(item,indexskuValue3) in gitem.childs"
                    :key="indexskuValue3"
                    :label="index"
                    :value="item.value"
                    :disabled="item.isgray"
                  >{{ item.value }}</Option>
                </Select>
              </div>
              <div
                :class="['add-cart',item.guigeList.length==1&&item.skuId ? 'onesku':'moresku']"
                :style="{ marginTop: item.skuValue&&item.skuValue ? '2.5rem':'' }"
                v-if="item.status == 0 || item.status ==3"
                @click="addCart(index,item)"
              >加入购物车</div>
            </div>
            <div class="remove herf_tilte" @click="cancleWish(index)">移除</div>
          </div>
        </div>
      </div>
      <div class="summary" @click="goMyWishList()">查看我的心愿清单</div>
    </template>
  </div>
</template>

<script>
export default {
  name: "MinLoveList",
  data() {
    return {
      chooseIndex: null,
      choosenum: 0,
      loaded: false,
      ishasskuid: false,
      wishtList: [],
      choosesize: "",
      chooseskuSpecValue0: "",
      chooseskuSpecValue1: "",
      chooseskuSpecValue2: "",
      API: this.$store.state.API,
      showList: false,
      placementtext: "top",
      model1: "",
      visitStatus: false
    };
  },
  props: {
    showLoveList: {
      type: Boolean,
      default: ""
    }
  },
  computed: {
    loveListFalg() {
      return this.$store.state.loveListFalg;
    },
    RefreshLoveList() {
      return this.$store.state.RefreshLoveList;
    },
    isExitlogin() {
      return this.$store.state.isExitlogin;
    }
  },
  watch: {
    showLoveList() {
      if (this.showLoveList) {
        this.gaViewItem(this.wishtList);
      }
    },
    loveListFalg(curVal, oldVal) {
      this.$emit("makeLoveListShow", true);
      //这里的curVal就是需要监听的值
    },
    RefreshLoveList(curVal, oldVal) {
      //这里的curVal就是需要监听的值
      this.getMyWishList();
    },
    isExitlogin(curVal, oldVal) {
      //监听是否退出
      //  然后查下登录状态
      this.getLoginStatus().then(res => {
        this.hasLogin = res;
        if(!res){
        this.getMyWishList();

        }
      });
    }
  },
  components: {},

  created() {
    this.getLoginStatus().then(res => {
      if (res) {
        return;
      }
      this.getMyWishList();
    });
  },
  methods: {
    getLoginStatus() {
      const that = this;
      return new Promise((resolve, reject) => {
        this.hasLogin = window.localStorage.getItem("token") ? false : true;
        resolve(this.hasLogin);
      });
    },
    //根据规格属性获取库存和价格
    getskuprice: function(data) {
      var that = this;
      // 去获取skuid
      return new Promise((resolve, reject) => {
        //参数部分
        var url = this.$store.state.API.pdp.getStocksAndPriceByType,
          params = {
            productId: data.productId,
            imageSpecId: data.imageSpecId,
            extraSpecId1: data.extraSpecId1,
            extraSpecId2: data.extraSpecId2,
            imageSpecValue: data.skuImageValue,
            extraSpecValue1: data.skuSpecValue1,
            extraSpecValue2: data.skuSpecValue2,
            openId: this.$store.state.openId || this.$store.state.userId
          };
        this.$http
          .post(url, that.$qs.stringify(params))
          .then(res => {
            if (res.data.returnData) {
              that.stocknum = res.data.returnData.stocks;
              that.goodsprice = parseFloat(res.data.returnData.price);
              that.discountprice = res.data.returnData.distributionPrice
                ? res.data.returnData.distributionPrice
                : parseFloat(res.data.returnData.discountPrice);
              that.skuid = res.data.returnData.id;

              that.ishasskuid = false;
              that.Taxes = 0;
              resolve(that.skuid);
            } else {
              this.ishasskuid = true;
              reject(res.data.message);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },

    async change_status(index, gindex) {
      this.chooseIndex = index;
      var item = this.wishtList[index];
      var data = {
        productId: item.baseDTO.id,
        imageSpecId: item.guigeList[0] ? item.guigeList[0].id : "",
        extraSpecId1: item.guigeList[1] ? item.guigeList[1].id : "",
        extraSpecId2: item.guigeList[2] ? item.guigeList[2].id : "",
        skuImageValue: item.skuValue,
        skuSpecValue1: item.skuValue2,
        skuSpecValue2: item.skuValue3
      };
    
      this.updateSkuId = await this.getskuprice(data);


      this.cancleWish(index, "update"); //修改
    },
    goPage(linkUrl, good, index) {
      var that = this;
      this.$router.push({
        name: "shopping",
        params: {
          friendly_url: linkUrl
        }
      });
      this.gaSelectContent(good, index);
    },

    //GA select_content埋点
    gaSelectContent(good, index) {
      this.$set(good, "list_position", index);
      this.$set(good, "list_name", "love_list_fw");
      this.$gaAction.select_content(good);
    },
    //GA add_to_cart埋点
    gaAddToCart(gaData) {
      this.$gaAction.add_to_cart(gaData, "love_list_fw");
    },
    //加入购物车
    async addCart(index, goodInfo) {

      let OpenId=await this.$utils.CheckOpenIdExist(this);
      this.gaAddToCart(goodInfo.baseDTO);
      let url = this.API.shopcart.addCart;
      var item = this.wishtList[index];
      this.chooseIndex = index;
      if (!item.skuId) {
        this.ishasskuid = true;
        return false;
      }
      let params = {
        openId: OpenId || this.$store.state.userId,
        skuId: item.skuId,
        count: item.checkNu,
        pageUrl: item.baseDTO.friendly_url,
        terminal: "WEB",
        source: "",
        imageUrl: "",
        sourceTb:'website'
      };
      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            let state_1 = this.$store.state.shopCartFalg;
            let state_2 = this.$store.state.RefreshShopCart;
            this.$store.commit("showShopCartPop", !state_1);
            // this.$Message.success("加入购物车成功");
            this.cancleWish(index);

            this.$store.commit(
              "RefreshLoveList",
              !this.$store.state.RefreshLoveList
            );
            this.$store.commit("RefreshShopCart", !state_2);
          } else {
            this.$Message.error(res.data.message);
          }
        })
        .catch(err => {});

    },
    //移除
    async cancleWish(index, type) {
      let url = this.API.my.addWish;
      var item = this.wishtList[index];
      let OpenId=await this.$utils.CheckOpenIdExist(this);
      var params = {};
      if (type == "update") {
        params = {
          merchantId: this.$store.state.storeId,
          openId: OpenId || this.$store.state.userId,
          productId: item.id,
          skuId: this.updateSkuId,
          id: item.id,
          skuImageValue: item.skuValue,
          skuSpecValue1: item.skuValue2,
          skuSpecValue2: item.skuValue3,
          skuNu: 1,
          flag: 0 //0：收藏，1：取消收藏
        };
      } else {
        params = {
          merchantId: this.$store.state.storeId,
          openId: OpenId || this.$store.state.userId,
          productId: item.id,
          skuId: item.skuid,
          id: item.id,
          skuImageValue: item.skuValue,
          skuSpecValue1: item.skuValue2,
          skuSpecValue2: item.skuValue3,
          skuNu: 1,
          flag: 1 //0：收藏，1：取消收藏
        };
      }
      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result && res.data.message == "success") {
            this.getMyWishList();

            if (type == "update") {
            } else {
              // this.$Message.success("移除成功");
            }
          } else {
            this.$Message.error(res.data.message);
          }
        })
        .catch(err => {});
    },

    async getMyWishList() {
      // /dbc/mini/collection/list
     let OpenId=await this.$utils.CheckOpenIdExist(this);
      var openId = OpenId || this.$store.state.userId;
      let url =
        this.API.my.getWishList +
        "?merchantId=" +
        this.$store.state.storeId +
        "&openId=" +
        openId;
      this.$http
        .get(url, {})
        .then(res => {
          if (res.data.result) {
            let list = [];
            let skus = res.data.returnData.skus;
            let invalidSkus = res.data.returnData.invalidSkus;
            list = skus.concat(invalidSkus);
            this.wishtList = list;
            this.$utils.updateImgOssSuffix(this); //检测是否支持webp格式
            for (var m = 0; m < this.wishtList.length; m++) {
              var guigelist = JSON.parse(this.wishtList[m].skuSpec).dtos;
              // 需要变灰的sku
              var guigestocklist = JSON.parse(this.wishtList[m].skuSpec)
                .garyDtos;

              if (guigestocklist.length <= 0) {
                //当没有库存信息时
                for (var n = 0; n < guigelist.length; n++) {
                  for (var j = 0; j < guigelist[n].childs.length; j++) {
                    guigelist[n].childs[j].isgray = true;
                  }
                }
                this.wishtList[m].guigeList = guigelist;
                setTimeout(() => {
                  this.loaded = true;
                }, 500);
              } else {
                for (var i = 0; i < guigelist.length; i++) {
                  for (var k = 0; k < guigestocklist.length; k++) {
                    if (guigelist[i].id == guigestocklist[k].categryId) {
                      for (var j = 0; j < guigelist[i].childs.length; j++) {
                        if (
                          guigelist[i].childs[j].value ==
                          guigestocklist[k].categryValue
                        ) {
                          if (guigestocklist[k].status == "1") {
                            guigelist[i].childs[j].isgray = false;

                            guigelist[i].childs[j].stocknum =
                              guigestocklist[k].stock;
                          } else {
                            guigelist[i].childs[j].ischk = false;
                            guigelist[i].childs[j].isgray = true;
                            guigelist[i].childs[j].stocknum = 0;
                          }
                        }
                      }
                    }
                  }
                }
                this.wishtList[m].guigeList = guigelist;
                setTimeout(() => {
                  this.loaded = true;
                }, 500);
              }
            }
            this.$store.commit("upDateLoveCount", list.length);

            setTimeout(() => {
              this.loaded = true;
            }, 500);
          } else {
            // this.$Message.error(res.data.message);
          }
        })
        .catch(err => {});
    },
    goMyWishList() {
      if (!window.localStorage.getItem("token")) {
        this.$store.commit("setValue", ["showLoginPop", true]);
      } else {
        this.$router.push({ path: "/account/love-list" });
      }
    },
    //GA view_item埋点
    gaViewItem(dataList) {
      if (dataList.length != 0) {
   
        let gaData = [];
        for (let i in dataList) {
          gaData.push(dataList[i].baseDTO);
        }
       
        this.$gaAction.view_item(gaData, "love_list_fw");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.min-bag-container {
  top: calc(100% - 0.1rem);
  width: 36rem;
  max-width: 36rem;
  position: absolute;
  right: 0;
  height: auto;
  max-height: 50rem;

  // position: relative;
  z-index: 51;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 0.1rem solid #eaeaea;
  background-color: #fff;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.4s ease-out, visibility 0.4s;
  &.show-cart {
    opacity: 1;
    visibility: visible;
  }
  .no-data {
    .title {
      text-align: left;
      padding: 2rem;
      border-bottom: 0.1rem solid #eaeaea;
    }
  }

  .cart-list {
    max-height: 50rem;
    overflow: auto;
    .cart-item {
      // display: flex;
      // border-top: 0.1rem solid #e5e5e5;
      position: relative;
      padding: 2rem;
      display: flex;
      border-bottom: 0.1rem solid #eaeaea;
      &:last-child {
        border-bottom: none;
      }

      .cart-img {
        // flex: 1.2;
        min-width: 9rem;
        max-width: 9rem;
      }
      .cart-info {
        display: flex;
        justify-content: space-between;
        flex: 1;
        margin-left: 2rem;
        color: #8e8f8b;

        .cart-info-detail {
          text-align: left;
          .good-price {
            padding-top: 0.5rem;
          }
          .good-name {
            display: flex;
            // justify-content: center;
            align-items: center;
            .last-pro {
              padding: 0.2rem 1.4rem;
              display: inline;
              border: 0.1rem solid #5c5d5f;
              text-transform: none;
              white-space: nowrap;
              color: #5c5d5f;
              margin-left: 0.6rem;
              display: none;
            }
          }
          .good-size {
            // margin: 2rem 0;
            margin-bottom: 0.3rem;
            margin-top: 2.5rem;
            &.more {
              margin-top: 0;
            }

            &.hint {
              // margin-top: 2rem;
              margin-top: 0;
              height: 1.8rem;
              color: #d0021b;
            }
            &.choose {
              margin: 0 0 2rem;
            }
          }
          .add-cart {
            color: #333333;
            background: #eaeaea;
            // position: absolute;
            // bottom: 2rem;
            margin-top: 1rem;
            font-size: 1.5rem;
            padding: 0.2rem 0rem;
            width: 10rem;
            text-align: center;
            cursor: pointer;
            &.onesku {
              position: initial;
              bottom: initial;
              margin-top: 2.5rem;
            }
            &.moresku {
              margin-top: 1.5rem;
            }
          }
        }
        .remove {
          color: #5c5d5f;
          cursor: pointer;
          position: absolute;
          bottom: 2rem;
          right: 2rem;
        }
      }
      .cart-right {
      }
    }
  }
  .summary {
    cursor: pointer;
    text-align: left;
    padding: 2rem;
    text-decoration: underline;
  }
  .go-cart {
    color: #5c5d5f;
    background-color: #fff;
    font-weight: 500;
    .icon {
      transform: rotate(-180deg);
    }
  }
}

/deep/.ivu-select-single .ivu-select-selection .ivu-select-placeholder,
.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  height: 2.4rem;
  line-height: 2.4rem;
  display: none;
}
/deep/.ivu-select-single .ivu-select-selection {
  width: 2.4rem;
  height: 2.4rem;
}
/deep/.ivu-select-placeholder {
  display: none !important;
}
/deep/.ivu-select-selected-value {
  display: none !important;
}

/deep/.ivu-select-single .ivu-select-selection .ivu-select-placeholder,
.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  display: none !important;
}
/deep/.ivu-select-arrow {
  right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/MinLoveList.vue